// extracted by mini-css-extract-plugin
export var cancelButton = "_o0-5";
export var content = "_o0-3";
export var createButton = "_o0-6";
export var drawerContainer = "_o0-0";
export var footer = "_o0-2";
export var header = "_o0-1";
export var orderFormColumn = "_o0-4";